import usePageTitle from "@entrilia/shared/hooks/usePageTitle";
import adminApi from "../../../api/adminApi";
import EmailDeliveryLog from "./EmailDeliveryLog";

const PortfolioEmailDeliveryLogPage = () => {
  usePageTitle("Email Delivery Log");

  return (
    <EmailDeliveryLog
      searchApi={adminApi.searchPortfolioSentEmails}
      startExportApi={adminApi.startPortfolioSentEmailsExport}
      getExportProgressApi={adminApi.getPortfolioSentEmailsExportProgress}
    />
  );
};

export default PortfolioEmailDeliveryLogPage;
